
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/v7/migrating-from-deprecated-apis",
      function () {
        return require("private-next-pages/material-ui/migration/v7/migrating-from-deprecated-apis.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/v7/migrating-from-deprecated-apis"])
      });
    }
  